import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { BinListComponent } from './bin-list.component';
import { BinesService } from './bines.service';
import { IBin } from './bin';
import * as myGlobals from './../global';
import { NaturalezasContableService } from './naturaleza-contable.service';
import { Observable } from 'rxjs/Observable';
import { NaturalezaContable } from './naturaleza-contable';
import { ITarjeta } from '../tarjetas/tarjeta';
import { TarjetasService } from '../tarjetas/tarjetas.service';
import { EmisoresService } from '../emisores/emisores.service';
import { IEmisor } from '../emisores/emisor';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-edit-bin',
  templateUrl: './edit-bin.component.html',
  styleUrls: ['./edit-bin.component.sass'],
  providers: [BinesService]
})
export class EditBinComponent implements OnInit, OnDestroy, AfterViewInit {
  bines: IBin[] = [];
  errorMessage = '';
  bin: IBin;
  accountingNatureSelected: string;
  cardBrandSelected: string;
  cardIssuerSelected: string;

  accountingNatureList: Observable<NaturalezaContable[]> = this.accountingNatureService.allRecords();
  cardBrandList: Observable<ITarjeta[]> = this.tarjetasService.getTarjetas();
  cardIssuerList: Observable<IEmisor[]> = this.emisoresService.getEmisores();

  constructor(
    public service: BinesService,
    private parent: BinListComponent,
    private accountingNatureService: NaturalezasContableService,
    private tarjetasService: TarjetasService,
    private emisoresService: EmisoresService
  ) {}

  ngOnInit() {
    console.log('EditBinComponent: OnInit: id: ', this.parent.editnumber);
    this.getBin(this.parent.editnumber);
    // console.log('EditBinComponent: OnInit: accountingNatureSelected: ', this.accountingNatureSelected);
    // this.accountingNatureSelected = this.bin.prefix;
    // console.log('EditBinComponent: OnInit: accountingNatureSelected: ', this.accountingNatureSelected);
  }

  ngAfterViewInit() {
    $('a[rel=bines]').addClass('selected');
  }

  edit(elemento): boolean {
    console.log('edit:' + elemento.parent.editnumber);
    const formData = {
      prefix: $('input[name=prefix]').val(),
      productName: $('input[name=productName]').val(), // TARJETA AMEXBANK,
      accountingNature: $('#accountingNature option:selected').val(), // C,
      cardBrand: $('#cardBrand option:selected').val(), // AMERICAN EXPRESS,
      cardIssuerId: $('#cardIssuerId option:selected').val(), // 583,
      cardIssuerName: '', // AMEXBANK,
      accountingNatureValue: '', // Crédito,
      productClass: $('input[name=productClass]').val(),
      status: $('#status option:selected').val(), // 1,
      chip: !!$('#chip').is(':checked'), // false
      requireCvv: !!this.bin.requireCvv,
      requireNip: !!this.bin.requireNip,
      prepaid: !!this.bin.prepaid,
      cashbackAllowed: !!this.bin.cashbackAllowed,
      interbankPaymentAllowed: !!this.bin.interbankPaymentAllowed,
      automaticChargesAllowed: !!this.bin.automaticChargesAllowed
    };
    console.log(formData);

    const parentRef = this.parent;

    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/bin/' + elemento.parent.editnumber,
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'PUT',
      data: JSON.stringify(formData)
    }).done(function(response) {
      console.log('delete sucess!!');
      parentRef.showBines = true;
      parentRef.showAddBin = false;
      parentRef.showEditBin = false;
    }).fail(function(jqXHR) {
      alert('No se pudo actualizar el bin: ' + errorMessageFromAjax(jqXHR));
    });
    return false;
  }

  getBin(id: number): any {
    this.service.getBin(id).subscribe(
      bin => {
        this.bin = bin;
        this.accountingNatureSelected = bin.accountingNature;
        this.cardBrandSelected = bin.cardBrand;
        this.cardIssuerSelected = bin.cardIssuerId;
        console.log('EditBinComponent: getBin: accountingNatureSelected: [', this.accountingNatureSelected, ']');
        console.log('EditBinComponent: getBin: cardBrandSelected: [', this.cardBrandSelected, ']');
        console.log('EditBinComponent: getBin: cardIssuerSelected: [', this.cardIssuerSelected, ']');
      },
      error => (this.errorMessage = error as any)
    );
  }

  cancelBin(): void {
    this.parent.showBines = true;
    this.parent.showAddBin = false;
    this.parent.showEditBin = false;
  }

  ngOnDestroy() {
    $('a[rel=bines]').removeClass('selected');
  }
}
